import { useValueHierarchy } from "./ValueHierarchyContext";

const ValueHierarchyBreadcrumb = () => {
  const { activePath, focusNode } = useValueHierarchy();
  if (!activePath.length) return null;

  return (
    <nav className="value-hierarchy-breadcrumb" aria-label="Caminho da EAP">
      <ol>
        {activePath.map((node, index) => (
          <li key={node.key}>
            {index > 0 && <span aria-hidden="true">›</span>}
            <button
              type="button"
              onClick={() => focusNode(node.key)}
              aria-label={`Ir para ${node.label}`}
            >
              {node.label}
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default ValueHierarchyBreadcrumb;
